<template>
  <div style="margin: 10px;">
    <p style="text-align: center; margin: 10px; font-weight: 600;">仁义商场洪水水位预警（内部使用）</p>
    <p style="text-align: center; margin: 0;">{{getFormattedDate()}}</p>
    <div style="width: 100%; height: 50vh;">
      <v-chart :options="options" ref="myChart"></v-chart>
    </div>
    <p style="">水位上涨速度为：<span style="font-weight: bold; color: red;">{{ riseRate.toFixed(3) }}</span> 米/小时</p>
    <p>当前水位: {{ currentPosition.toFixed(2) }}米</p>
    <p style="font-weight: bold; color: red;" v-if="currentPosition >= floor1">水已漫进商场</p>
    <p>水漫进商场一层地面还有：
      <span style="font-weight: bold; color: red;">{{(floor1 - currentPosition).toFixed(2)}}米<span v-if="riseRate > 0 && currentPosition < floor1">，{{(timeToLeft).toFixed(2)}}小时</span></span>
    </p>
    <div style="font-size: 14px;margin-top: 20px;">
      <div>数据说明：</div>
      <div>该测量数据仅供参考</div>
      <div>水位低于{{ minPosition }}米无法测量，如果水位低于该高度将显示为{{ minPosition }}米</div>
      <div>漫进商场一层地面水位为{{floor1}}米</div>
      <div>水位上涨速度为负数则为水位下降</div>
      <div>水位上涨速度以最近15分钟计算</div>
      <div>距离水漫进商场时间为水位上涨速度预估计算得出，不代表真实时间</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watchEffect } from "vue";
import "echarts";
import VChart from "vue-echarts";

const floor1 = ref(103.32);
const minPosition = ref(0);

// 使用ref创建一个ECharts实例
const myChart = ref(null);

function getFormattedDate() {
  var date = new Date(); // 获取当前日期
  var year = date.getFullYear(); // 获取年份
  var month = date.getMonth() + 1; // 获取月份，月份从0开始，所以需要+1
  var day = date.getDate(); // 获取日

  // 确保月份和日期是两位数
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;

  // 拼接成指定的日期格式
  return year + '年' + month + '月' + day + '日';
}

// 使用ref定义图表的配置项
const options = ref({
  tooltip: {
    trigger: "axis",
  },
  xAxis: {
    type: "time",
    boundaryGap: false,
    axisLabel: {
      rotate: 45,
      formatter: {
        day: '{d}日',
      }
    },
  },
  yAxis: {
    type: "value",
    axisLabel: {
      formatter: "{value}米",
    },
    min: minPosition.value, // 设置 y 轴的最小值
    max: null,  // 设置 y 轴的最大值
  },
  grid: {
    top: '30', // 顶部内边距
    left: '55', // 左侧内边距
    right: '10', // 右侧内边距
    bottom: '25%' // 底部内边距
  },
  series: [
    {
      data: [],
      type: "line",
      symbol: 'none',
      smooth: false,
    },
  ],
  dataZoom: [{
    type: 'slider',
    show: true,
    xAxisIndex: 0,
    brushSelect: false,
    top: '85%' // 将滑动条放在图表下方
  }],
});

function calculateRiseRate(dataArray, timeSeconds) {
  // 将数据按照测量时间升序排列
  dataArray.sort((a, b) => a.测量时间 - b.测量时间);

  // 找到timeSeconds秒前的数据点，并找到最近的数据点
  const endIndex = dataArray.length - 1; // 假设数组已经排序，最后一个元素是最近的数据点
  const ago = dataArray[endIndex].测量时间 - timeSeconds;
  const startIndex = dataArray.findIndex(data => data.测量时间 >= ago);

  // 检查是否有足够的数据点
  if (startIndex === -1 || endIndex === -1 || startIndex >= endIndex) {
    return 0;
  }

  // 获取起始和结束水位
  const startWaterLevel = dataArray[startIndex].数据值;
  const endWaterLevel = dataArray[endIndex].数据值;

  // 计算时间差（秒）
  const startTime = dataArray[startIndex].测量时间;
  const endTime = dataArray[endIndex].测量时间;
  const timeDifference = endTime - startTime;

  // 计算水位上涨速度（米/小时）
  const riseRate = (endWaterLevel - startWaterLevel) / timeDifference * 3600;

  return riseRate;
}

const riseRate = ref(0)
const currentPosition = ref(0)
const timeToLeft= ref(0) //水漫进商场剩余时间，小时
const apiBaseUrl = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');

// 模拟获取后端数据
const fetchData = async () => {
  const response = await (await fetch(`${apiBaseUrl}/check`)).json();
  const data = response.values;
  minPosition.value = parseFloat(response.minPosition);
  const valueData = data.map((item) => [new Date(item.测量时间 * 1000), item.数据值 + minPosition.value]);

  options.value.series[0].data = valueData;
  options.value.yAxis.min = minPosition.value;

  riseRate.value = calculateRiseRate(data, 900);
  currentPosition.value = data[data.length - 1].数据值 + minPosition.value;
  if(riseRate.value > 0) {
    timeToLeft.value = (floor1.value - currentPosition.value) / riseRate.value;
  } else {
    timeToLeft.value = 0;
  }
};

onMounted(async() => {
  fetchData();
  setInterval(() => {
    fetchData();
  }, 60000)
});

// 定义一个方法来更新图表
const updateChart = () => {
  if (myChart.value !== null && options.value) {
    myChart.value.setOption(options.value);
  }
};

// 监听options的变化，以更新图表
watchEffect(() => {
  updateChart();
});
</script>